import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import auth from '@/services/auth'
import store from "@/store"

Vue.use(VueRouter)


const router = new VueRouter({
    mode: 'history',
    routes
})



router.beforeEach((routeTo, routeFrom, next) => {
    const authRequired = routeTo.matched.some(route => route.meta.authRequired)
    if (!authRequired) return next()
    if (auth.isAuthenticated()) {
        next()
        if(!store.getters['auth/isAdmin'] && routeTo.matched.some(route => route.meta.isAdmin)){
            next('/')
        }
    } else {
        redirectToLogin()
    }


    function redirectToLogin() {
        store.commit("utils/setOpenNav", false)
        next({
            path: '/login',
            query: {
                redirectFrom: routeTo.fullPath
            }
        })


    }
})

export default router